<template>
	<v-col class="dashboard">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Dashboard</div>
		</div>

		<div class="pt-1 pb-5 mb-3 d-flex font-size-10 grey--text">
			<router-link to="/">
				<div class="d-flex">
					<v-icon small color="grey">mdi-home</v-icon>
					<div class="pl-2 grey--text">Dashboard</div>
				</div>
			</router-link>
		</div>

		<!-- new dashboard -->
		<template v-if="!loading">
			<div class="mt-5">
				<!-- info profile -->
				<v-row>			
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="align-stretch" v-if="Object.values(myProfile).length > 0">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<v-row>
									<v-col cols="12" class="d-flex flex-row align-center justify-space-between">
										<div class="font-size-12 cl-grey font-weight-bold">Profil</div>
										<v-btn color="primary" small depressed class="text-capitalize rounded-xl font-weight-bold" @click="goProfile">
											Lihat Detail
										</v-btn>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="12" sm="12" md="4" class="d-flex flex-column flex-stretch text-center justify-start align-center">
										<v-img height="120" width="120" class="user-img mx-auto rounded-pill hover-shadow" style="max-height: 120px;" :src="(myProfile.member_image_url) ? myProfile.member_image_url : 'assets/image/profile-pict.png'"></v-img>
										<div class="bottom-shadow"></div>
									</v-col>

									<v-col cols="12" sm="12" md="8" class="d-none d-md-block">
										<div class="mb-4 font-size-14 font-weight-600 cl-primary text-uppercase">{{ myProfile.member_name }}</div>
										<v-row class="mb-3">
											<v-col cols="12" sm="12" md="6" v-if="myProfile.member_network_code">
												<div class="font-size-10 cl-grey">Kode Mitra</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_network_code }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" v-if="!myProfile.member_network_code">&nbsp;</v-col>
											<v-col cols="12" sm="12" md="6">
												<div class="font-size-10 cl-grey">Sponsor</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Tanggal Gabung</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_join_datetime | tanggal }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Nomor HP</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_mobilephone ? myProfile.member_mobilephone : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="12" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Email</div>
												<div class="font-size-11 cl-grey font-weight-600" v-html="$options.filters.longText(myProfile.member_email, 20)"></div>
											</v-col>
										</v-row>
									</v-col>

									<v-col cols="12" sm="12" md="8" class="d-xs-flex d-sm-flex d-md-none justify-sm-center text-sm-center">
										<div class="mb-4 font-size-14 font-weight-600 cl-primary text-uppercase">{{ myProfile.member_name }}</div>
										<v-row class="mb-3">
											<v-col cols="12" sm="12" md="6" v-if="myProfile.member_network_code">
												<div class="font-size-10 cl-grey">Kode Mitra</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_network_code }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" v-if="!myProfile.member_network_code">&nbsp;</v-col>
											<v-col cols="12" sm="12" md="6">
												<div class="font-size-10 cl-grey">Sponsor</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_sponsor_network_code ? myProfile.member_sponsor_network_code : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Tanggal Gabung</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_join_datetime | tanggal }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="6" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Nomor HP</div>
												<div class="font-size-11 cl-grey font-weight-600">{{ myProfile.member_mobilephone ? myProfile.member_mobilephone : '-' }}</div>
											</v-col>
											<v-col cols="12" sm="12" md="12" class="pt-0 pt-md-1">
												<div class="font-size-10 cl-grey">Email</div>
												<div class="font-size-11 cl-grey font-weight-600" v-html="$options.filters.longText(myProfile.member_email, 20)"></div>
											</v-col>
										</v-row>
									</v-col>
								</v-row>
								<v-card-actions class="px-0 pb-0">
									<div class="text-center text-md-left">
										<div class="font-size-10 cl-grey">Link Referral</div>
										<div class="font-size-10 cl-primary font-weight-600 cursor-pointer" @click="goPublicRegistration(referral.code_referral)">{{ appPublicHost }}{{ referral.code_referral }}</div>
										<input class="copy-referral" type="hidden" v-model="linkReferral" ref="linkReferral">
										<v-btn color="primary" small outlined class="mt-1 text-capitalize rounded-xl font-weight-bold" @click="copyReferral">
											{{ isCopyReferral ? 'Tersalin' : 'Salin' }}
										</v-btn>
									</div>
								</v-card-actions>
							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<v-scroll-x-reverse-transition mode="in-out">
						<v-col cols="12" sm="12" md="6" class="align-stretch" v-if="Object.values(myProfile).length > 0 && networkType">
							<v-card class="pa-8 elevation-0 rounded-xl hover-shadow fill-height mitra-card" :style="{ 'background-image': 'url(' + networkType.bgs + ')' }">
								<v-row justify="center" class="fill-height flex-stretch mt-0">
									<v-col cols="12" sm="12" md="4" class="pa-4 d-flex align-center justify-center">
										<v-img width="160" style="height: auto;max-width: 100%;" class="mx-auto" :src="networkType.badges"></v-img>
									</v-col>
									<v-col cols="12" sm="12" md="8">
										<div class="rank-text">
											<div class="font-size-14 font-weight-500 cl-darkgrey">Peringkat Kemitraan Anda Saat Ini</div>
											<h2 class="font-weight-bold text-uppercase mt-3" :style="'color:' + networkType.color">
												{{ myProfile.member_network_type }}
											</h2>
											<h4 class="d-block mb-5 pb-3">Periode {{ new Date() | bulantahun }}</h4>
											<v-btn :color="networkType.color" class="white--text font-weight-bold rounded-xl" @click="dialogMemberCard = !dialogMemberCard">Tampilkan Member Card Saya</v-btn>
										</div>
									</v-col>
								</v-row>
							</v-card>

							<v-dialog
								v-model="dialogMemberCard"
								max-width="700"
								style="background: #fff;"
								overlay-color="#fff"
							>
								<div class="d-block" style="padding: 25px;background: #fff;">
									<v-card width="650" height="380" class="py-2 px-0 elevation-0 rounded-xl hover-shadow fill-height mitra-card" :style="{ 'background-image': 'url(' + networkType.cards + ')' }" style="border: 1px solid #664E3B;">
										<v-row justify="center" class="fill-height flex-stretch mt-0">
											<v-col cols="7" sm="7" md="7">
												<div class="d-flex flex-column h-100 align-center justify-center">
													<v-chip
														:color="networkType.color"
														pill
														large
														class="white--text px-7 mb-3 text-uppercase"
													>
														<h4>{{ myProfile.member_name }}</h4>
													</v-chip>
													<v-chip
														:color="networkType.color"
														pill
														outlined
														class="px-7 py-5"
														style="border-radius: 25px;"
													>
														<h4 :style="'color:' + networkType.color">{{ myProfile.member_ref_network_code }}</h4>
													</v-chip>
												</div>
											</v-col>

											<v-col cols="4" sm="4" md="4">
												<div class="d-flex flex-column h-100 align-center justify-end">
													<h2 class="font-weight-bold text-uppercase mt-3 mb-2 pb-1" :style="'color:' + networkType.color + ';border-bottom: 1px solid ' + networkType.color">
														{{ myProfile.member_network_type }}
													</h2>
													<h5 class="d-block pb-5" :style="'color:' + networkType.color">{{ new Date() | bulantahun }}</h5>
												</div>
											</v-col>
										</v-row>
									</v-card>
								</div>
							</v-dialog>
						</v-col>
					</v-scroll-x-reverse-transition>
				</v-row>

				<!-- sisa perhitungan komisi -->
				<v-row>
					<v-col cols="12">
						<v-card class="pa-4 elevation-0 rounded-xl fill-height">
							<div class="pb-3 d-block font-size-12 cl-black font-weight-500">Sisa Perhitungan Komisi</div>
							<v-row class="ml-0">
								<v-col cols="12" md="4" class="pl-0">
									<v-card outlined color="#41c1c838" class="elevation-0 rounded-xl hover-shadow w-100 ">
										<v-card-subtitle class="d-flex flex-column grey--text text--darken-3 pb-1">
											<span class="font-weight-bold">Sisa Perhitungan Komisi Dropship</span>
										</v-card-subtitle>
										<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ leftOver.point_balance_dropship_value | toRupiah }}</div>
									</v-card>
								</v-col>
								<v-col cols="12" md="4" class="pt-0 pl-0 pt-md-3">
									<v-card outlined color="#41c1c838" class="elevation-0 rounded-xl hover-shadow w-100 ">
										<v-card-subtitle class="d-flex flex-column grey--text text--darken-3 pb-1">
											<span class="font-weight-bold">Sisa Perhitungan Komisi Margin</span>
										</v-card-subtitle>
										<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ leftOver.point_balance_cashback_value | toRupiah }}</div>
									</v-card>
								</v-col>
								<v-col cols="12" md="4" class="pt-0 pl-0 pt-md-3">
									<v-card outlined color="#41c1c838" class="elevation-0 rounded-xl hover-shadow w-100 ">
										<v-card-subtitle class="d-flex flex-column grey--text text--darken-3 pb-1">
											<span class="font-weight-bold">Total Sisa Perhitungan Komisi</span>
										</v-card-subtitle>
										<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ leftOver.point_balance_total_value | toRupiah }}</div>
									</v-card>
								</v-col>
								<v-col cols="12" class="pl-0 pt-0 font-size-10 cl-grey font-weight-500">
									* Sisa perhitunggan komisi akan diupdate pada keesokkan hari
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>

				<!-- potensi komisi -->
				<v-row justify="center">
					<v-col cols="12" sm="12" md="4" xl="4" class="flex-stretch">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow primary fill-height d-flex align-center">
							<v-row class="align-center h-100 my-2">
								<v-col cols="3" sm="3" md="3" class="pr-0 my-auto text-center">
									<img class="img-fluid filter-white" src="assets/icon/wallet.svg" style="width: 70%;">
								</v-col>
								<v-col cols="9" sm="9" md="9">
									<template v-if="Object.keys(ewalletBalance).length > 0">
										<div class="font-size-18 white--text font-weight-bold">{{ ewalletBalance.balance.bonus_balance | toRupiah }}</div>
										<div class="font-size-12 cl-white">Total Komisi Anda</div>
									</template>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
					<v-col cols="12" sm="12" md="8" xl="8" class="flex-stretch">
						<v-card class="elevation-0 rounded-xl pb-2 fill-height">
							<v-card-title style="font-size: 18px!important;">
								<v-icon dense class="mr-2">mdi-wallet-giftcard</v-icon>Potensi Komisi Hari Ini
							</v-card-title>
							<div class="d-block px-5 pb-5">
								<div class="d-none d-md-flex flex-row align-center justify-center">
									<div class="d-flex flex-grow-1 flex-shrink-1" :class="(idk === 0) ? 'ml-0 mr-2' : (idk === (bonusPotency.length - 1) ? 'ml-2 mr-0' : 'mx-2')" :style="{ width: (100 / bonusPotency.length) + '%' }" v-for="(komisi, idk) in bonusPotency" :key="idk">
										<v-card outlined color="#41c1c838" class="elevation-0 rounded-xl hover-shadow w-100 ">
											<v-card-subtitle class="d-flex flex-column black--text lighten-3 pb-1">
												<span class="font-weight-bold">{{ komisi.label }}</span>
											</v-card-subtitle>
											<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ komisi.value | toRupiah }}</div>
										</v-card>
									</div>
								</div>
								
								<v-row justify="start" class="d-flex d-md-none">
									<v-col cols="12" sm="12" md="12" class="py-1" v-for="(komisi, idk) in bonusPotency" :key="idk">
										<v-card outlined color="#41c1c838" class="elevation-0 rounded-xl hover-shadow">
											<v-card-subtitle class="black--text lighten-3 font-weight-bold pb-1">{{ komisi.label }}</v-card-subtitle>
											<div class="d-block px-4 pb-4 font-size-14 cl-secondary font-weight-600">{{ komisi.value | toRupiah }}</div>
										</v-card>
									</v-col>
								</v-row>
							</div>
						</v-card>
					</v-col>
				</v-row>

				<!-- report membership -->
				<v-row>
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="3" md="3" class="flex-stretch">
							<v-card class="pa-5 elevation-0 rounded-xl hover-shadow mb-3">
								<div class="d-flex flex-column justify-start text-center my-4">
									<div class="d-flex flex-column align-center text-center">
										<v-icon color="primary" light size="72">mdi-account-group-outline</v-icon>
										<div class="font-size-12 gray--text darken-1 font-weight-bold mb-3" style="line-height: normal;">Total Mitra Saya</div>
									</div>

									<div class="font-size-22 cl-secondary darken-5 font-weight-600">{{ networkSummary.total_member | toNumber }}</div>
								</div>
							</v-card>

							<v-card class="pa-5 elevation-0 rounded-xl hover-shadow mb-3" color="green">
								<div class="d-flex flex-row align-center">
									<v-icon color="white" light size="36">mdi-account-plus-outline</v-icon>
									<div class="d-flex flex-column justify-start pl-5">
										<div class="font-size-10 white--text darken-1 font-weight-bold" style="line-height: normal;">Registrasi Mitra Hari Ini</div>
										<div class="font-size-16 white--text darken-5 font-weight-600">{{ networkSummary.total_member_join_today | toNumber }}</div>
									</div>
								</div>
							</v-card>

							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow" color="orange">
								<div class="d-flex flex-row align-center">
									<v-icon color="white" light size="36">mdi-account-clock-outline</v-icon>
									<div class="d-flex flex-column justify-start pl-5">
										<div class="font-size-10 white--text darken-1 font-weight-bold" style="line-height: normal;">Menunggu Approval Admin</div>
										<div class="font-size-16 white--text darken-5 font-weight-600">{{ networkSummary.total_member_waiting_approve | toNumber }}</div>
									</div>
								</div>
							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="3" md="3" class="flex-stretch">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<div class="d-block font-size-12 cl-black font-weight-500 mb-5">Registrasi Mitra Terbaru</div>

								<template v-if="networkSummary && networkSummary.ten_member_last_join">
									<template v-if="networkSummary.ten_member_last_join.length > 3">
										<carousel v-bind="slideSetting" id="memberSlide" :style="{height: '372px', overflow: 'hidden'}">
											<div v-for="downline in networkSummary.ten_member_last_join" :key="downline.member_network_code">
												<div class="d-flex align-start justify-start mb-2 pb-0">
													<v-icon color="grey" size="36">mdi-account-circle-outline</v-icon>
													<div class="d-flex flex-column justify-start pl-5">
														<div class="d-block font-size-11 cl-primary font-weight-600">{{ downline.member_network_code }}</div>
														<div class="d-block font-size-11 cl-grey text-capitalize"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
														<div class="d-block font-size-11 cl-grey font-weight-500 text-capitalize">{{ downline.member_city }}</div>
														<div class="d-block font-size-11 cl-grey">{{ downline.member_join_datetime | tanggaljam }}</div>
													</div>
												</div>
											</div>
										</carousel>
									</template>
									<template v-else>
										<v-row v-for="downline in networkSummary.ten_member_last_join" :key="downline.member_network_code">
											<v-col cols="12" sm="12" md="12" class="d-flex align-start justify-start mb-1 pb-0">
												<v-icon color="grey" size="36">mdi-account-circle-outline</v-icon>
												<div class="d-flex flex-column justify-start pl-5">
													<div class="d-block font-size-11 cl-primary font-weight-600">{{ downline.member_network_code }}</div>
													<div class="d-block font-size-11 cl-grey text-capitalize"><div v-html="$options.filters.longText(downline.member_name, 17)"></div></div>
													<div class="d-block font-size-11 cl-grey font-weight-500 text-capitalize">{{ downline.member_city }}</div>
													<div class="d-block font-size-11 cl-grey">{{ downline.member_join_datetime | tanggaljam }}</div>
												</div>
											</v-col>
										</v-row>
									</template>
								</template>

								<template v-else>
									<div class="d-flex flex-column fill-height align-center justify-center pa-5">
										<v-icon color="grey" large>mdi-information-outline</v-icon>
										<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data daftar downline yang ditampilkan.</div>
									</div>
								</template>
							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="flex-stretch" v-if="growthSummary.length > 0">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<div class="d-block font-size-12 cl-black font-weight-500 mb-5">Pertumbuhan Mitra Minggu Ini</div>

								<v-row>
									<v-col cols="12">
										<div id="chart-netgrow">
											<template v-if="netGrow.series[0].data.length > 0">
												<apexchart type="area" height="350" :options="netGrow.chartOptions" :series="netGrow.series"></apexchart>
											</template>
											<template v-else>
												<div class="d-flex flex-column fill-height align-center justify-center pa-5">
													<v-icon color="grey" large>mdi-information-outline</v-icon>
													<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data pertumbuhan mitra yang ditampilkan.</div>
												</div>
											</template>
										</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>
				</v-row>

				<!-- report sales -->
				<v-row>
					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="flex-stretch">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<div class="d-block font-size-12 cl-black font-weight-500 mb-5">Ringkasan Transaksi Bulan Ini</div>

								<v-row>
									<v-col class="py-0" cols="12" sm="12" md="12">
										<v-card class="elevation-0 px-2">
											<div class="d-flex flex-row justify-end text-center">
												<!-- <v-icon color="green" light size="60">mdi-account-group-outline</v-icon> -->
												<div class="d-flex flex-column align-start text-right ml-7">
													<div class="d-block font-size-10 text-right grey--text lighten-3 font-weight-bold mb-0" style="line-height: normal;">Jumlah Transaksi</div>
													<div class="d-block font-size-22 text-right black--text darken-5 font-weight-600 w-100">{{ transactionSummary.transaksi_this_month | toNumber }}</div>
												</div>
											</div>
										</v-card>
									</v-col>

									<v-col cols="12" sm="12" md="12">
										<div id="chart-rincian-transaksi" class="">
											<template v-if="!transactionSummary && !transactionSummary.hasOwnProperty('transaction_by_status')">
												<div class="empty-pie" style="width:135px; height: 135px;"></div>
											</template>
											<apexchart type="pie" :options="rincianTransaksi.chartOptions" :series="rincianTransaksi.series" height="180"></apexchart>
										</div>
									</v-col>
								</v-row>

							</v-card>
						</v-col>
					</v-scroll-x-transition>

					<v-scroll-x-transition mode="in-out">
						<v-col cols="12" sm="6" md="6" class="flex-stretch">
							<v-card class="pa-4 elevation-0 rounded-xl hover-shadow fill-height">
								<div class="d-block font-size-12 cl-black font-weight-500 mb-5">Ringkasan Transaksi 7 Hari Terakhir</div>

								<v-row>
									<v-col cols="12">
										<div id="chart-salesgrow">
											<template v-if="transactionSummary && transactionSummary.hasOwnProperty('transaksi_last_seven_day')">
												<apexchart type="area" height="210" :options="salesGrow.chartOptions" :series="salesGrow.series"></apexchart>
											</template>
											<template v-else>
												<div class="d-flex flex-column fill-height align-center justify-center pa-5">
													<v-icon color="grey" large>mdi-information-outline</v-icon>
													<div class="font-size-10 mt-4 text-center cl-grey">Belum ada data ringkasan transaksi yang ditampilkan.</div>
												</div>
											</template>
										</div>
									</v-col>
								</v-row>
							</v-card>
						</v-col>
					</v-scroll-x-transition>
				</v-row>
			</div>
		</template>

		<template v-else>
			<loaderdashboard></loaderdashboard>
		</template>
		<!-- end new dashboard -->

	</v-col>
</template>

<script>
	import { mapActions, mapState } from 'vuex'
	import carousel from 'vue-slick-carousel'
	import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
	import VueApexCharts from 'vue-apexcharts'
	import loaderDashboard from './components/loaderDashboard'

	export default {
		components: {
			apexchart: VueApexCharts,
			loaderdashboard: loaderDashboard,
			carousel,
		},
		data() {
			function formatRupiah(bilangan) {
				if (bilangan && bilangan >= 1000) {
					var	reverse = bilangan.toString().split('').reverse().join(''),
					ribuan 	= reverse.match(/\d{1,3}/g);
					ribuan	= ribuan.join('.').split('').reverse().join('');

					return ribuan;
				} else {
					return Number(bilangan.toFixed(2))
				}
			}

			function formatKomisLabel(label) {
				var	text = label.replace('Komisi', 'K. ').replace('Repeat Order', 'RO')
				return text;
			}

			return {
				loading: false,
				growthLoading: false,
				fiveDownline: '',
				isActiveMember: false,
				networkType: null,
				dialogMemberCard: false,
				linkReferral: '',
				isCopyReferral: false,
				kemitraan: [
					{
						type_id: '1',
						color: '#86D4FF',
						badges: 'assets/icon/balmed-sahabat.png',
						bgs: 'assets/icon/bg-sahabat.png',
						cards: 'assets/icon/member-card-sahabat.png',
						classText: 'mitra-bronze'
					},
					{
						type_id: '2',
						color: '#1CC5DC',
						badges: 'assets/icon/balmed-duta.png',
						bgs: 'assets/icon/bg-duta.png',
						cards: 'assets/icon/member-card-duta.png',
						classText: 'mitra-silver'
					},
					{
						type_id: '3',
						color: '#96BAFF',
						badges: 'assets/icon/balmed-juragan.png',
						bgs: 'assets/icon/bg-juragan.png',
						cards: 'assets/icon/member-card-juragan.png',
						classText: 'mitra-gold'
					},
					{
						type_id: '4',
						color: '#3FBCC3',
						badges: 'assets/icon/balmed-sultan.png',
						bgs: 'assets/icon/bg-sultan.png',
						cards: 'assets/icon/member-card-sultan.png',
						classText: 'mitra-diamond'
					}
				],

				slideSetting: {
					'dots': true,
					'infinite': true,
					'slidesToShow': 3,
					'slidesToScroll': 3,
					'vertical': true,
					'autoplay': true,
					'verticalSwiping': true
				},

				summaryKomisi: {
					series: [{
						name: 'Komisi',
						data: []
					},{
						name: 'Saldo',
						data: []
					}, {
						name: 'Dibayarkan',
						data: []
					}],
					chartOptions: {
						chart: {
							type: 'bar',
							height: 500
						},
						plotOptions: {
							bar: {
								horizontal: true,
								dataLabels: {
									position: 'top',
								},
							}
						},
						dataLabels: {
							enabled: false,
							offsetX: -6,
							style: {
								fontSize: '9px',
								colors: ['#fff']
							},
							background: {
								padding: 6
							},
							formatter: function(value) {
								if(value != undefined) return formatRupiah(value);
							}
						},
						stroke: {
							show: true,
							colors: ['#fff']
						},
						tooltip: {
							shared: true,
							intersect: false,
							y: {
								formatter: function(value) {
									if(value != undefined) return 'Rp ' + formatRupiah(value);
								}
							},
						},
						xaxis: {
							categories: [],
							labels: {
								formatter: function(value) {
									if(value != undefined) return formatRupiah(value);
								}
							}
						},
					},
				},

				rincianTransaksi: {
					series: [],
					chartOptions: {
						chart: {
							size: '200px',
							offsetY: -30
						},
						colors: ['#feb019', '#ff4560', '#775dd0', '#24ae21', '#d2dc46', '#fb5d00'],
						labels: [],
						responsive: [{
							breakpoint: 480,
							options: {
								chart: {
									width: '200px',
								},
								legend: {
									position: 'right'
								}
							}
						}],
						legend: {
							position: 'right',
							fontSize: 9,
							formatter: function(seriesName, opts) {
								return [ '<span>' + formatKomisLabel(seriesName) + '</span>', '<span class="font-weight-bold"> ' + formatRupiah(opts.w.globals.series[opts.seriesIndex]) + '</span>']
							}
						},
						tooltip: {
							y: {
								formatter: function(value) {
									if(value != undefined) return formatRupiah(value);
								}
							}
						},
					},
				},

				netGrow: {
					series: [
					{
						name: 'Registrasi',
						data: []
					}, 
					// {
					// 	name: 'Aktivasi',
					// 	data: []
					// }
					],

					chartOptions: {
						colors: ['#3CB7BF'],
						chart: {
							width: '100%',
							height: 350,
							stacked: true,
							type: 'area'
						},
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'smooth'
						},
						xaxis: {
							type: 'datetime',
							categories: []
						},
						yaxis: {
							labels: {
								formatter: function(val) {
									return val.toFixed(0)
								}
							}
						},
						tooltip: {
							x: {
								format: 'dd MMM yyyy'
							},
						},
					},
				},

				salesGrow: {
					series: [
					{
						name: 'Transaksi',
						data: []
					}
					],

					chartOptions: {
						colors: ['#ff9800'],
						chart: {
							width: '100%',
							height: 350,
							stacked: true,
							type: 'area'
						},
						dataLabels: {
							enabled: false
						},
						stroke: {
							curve: 'smooth'
						},
						xaxis: {
							type: 'datetime',
							categories: []
						},
						yaxis: {
							labels: {
								formatter: function(val) {
									return val.toFixed(0);
								}
							}
						},
						tooltip: {
							x: {
								format: 'dd MMM yyyy'
							},
						},
					},
				}
			}
		},
		computed: {
			...mapState('profile', ['myProfile']),
			...mapState('bonus', ['listSummaryBonus', 'listBonusToday']),
			...mapState('network', ['listDownline']),
			...mapState('dashboard', ['leftOver', 'growthSummary', 'networkSummary', 'transactionSummary', 'bonusPotency', 'referral']),
			...mapState('bonus', ['ewalletBalance']),
		},
		methods: {
			...mapActions('profile', ['getProfileMitra']),
			...mapActions('bonus', ['getSummaryBonus', 'getDetailBonusToday']),
			...mapActions('network', ['getDownline']),
			...mapActions('dashboard', ['getLeftover', 'getGrowthSummary', 'getTotalMember', 'getTransactionSummary', 'getBonusPotency', 'getReferral']),
			...mapActions('bonus', ['getEwalletBalance']),

			goPublicRegistration(referral) {
				let routeData = this.appPublicHost + referral
				window.open(routeData, '_blank');
			},
			copyReferral() {
				let textToCopy = document.querySelector('.copy-referral')
				try {
					textToCopy.setAttribute('type', 'text')
					textToCopy.select()
					document.execCommand("copy")
					this.isCopyReferral = true
					setTimeout(() => {
						this.isCopyReferral = false
					}, 2000)
				} catch(err){
					alert('Oops, unable to copy')
				}
				textToCopy.setAttribute('type', 'hidden')
				window.getSelection().removeAllRanges()
			},
			goActivation() {
				this.$router.push({name: 'aktivasi'})
			},
			goProfile() {
				this.$router.push({name: 'profil'})
			},
			async getData() {
				this.loading = await true
				await this.getProfileMitra()
				await this.getLeftover()
				await this.getReferral().then(() => {
					this.linkReferral = process.env.VUE_APP_API_PUBLIC_HOST + this.referral.code_referral
				})
				await	this.getNetworkType(this.myProfile.member_network_type_id)
				await	this.getGrowthSummary().then(() => {
					if (this.growthSummary) {
						this.setNetgrowSummaries(this.growthSummary)
					}
				})
				await	this.getTotalMember()
				await	this.getTransactionSummary().then(() => {
					if (this.transactionSummary) {
						this.setSalesgrowSummaries(this.transactionSummary.transaksi_last_seven_day)
						this.setDataRincianTransaksi(this.transactionSummary.transaction_by_status)
					}
				})
				await	this.getBonusPotency()
				await	this.getEwalletBalance()

				setTimeout(() => {
					this.loading = false
				}, 300)
			},
			sliceDownline() {
				let cloneDownline = [...this.listDownline]
				this.fiveDownline = cloneDownline.slice(0,10)
			},

			getNetworkType(type_id) {
				this.networkType = this.kemitraan.find(x => x.type_id === type_id)
			},

			setDataRincianTransaksi(data) {
				if (data) {
					for (const key in data) {
						this.rincianTransaksi.series.push(data[key].value)
						this.rincianTransaksi.chartOptions.labels.push(data[key].label)
					}
				}
			},

			async setNetgrowSummaries(data) {
				this.netGrow.series[0].data = await data.map((el) => parseInt(el['member_registration']))
				// this.netGrow.series[1].data = await data.map((el) => el['member_activation'])
				this.netGrow.chartOptions.xaxis.categories = await data.map((el) => el['member_date'])
			},

			async setSalesgrowSummaries(data) {
				this.salesGrow.series[0].data = await data.map((el) => el['transaction_total'])
				this.salesGrow.chartOptions.xaxis.categories = await data.map((el) => el['transaction_date'])
			},

			async checkMemberActivation(data) {
				if (data.bin_network_id === "0" || data.bin_network_id === 0) this.isActiveMember = false
				else this.isActiveMember = true
			},
		},
		created() {
			this.$store.dispatch('setPageTitle', `Dashboard`)
			this.getData()
		}
	};
</script>

<style lang="scss">
	.serial-list {
		margin-top: 7px;
		li {
			line-height: 1.1;
		}
	}

	.rank-text {
		background: rgba(255,255,255, 0.85);
    border-radius: 25px;
	}

	.text-sm-center {
		text-align: left;
	}

	@media (max-width: 599px) {
		.text-sm-center {
			text-align: center;
		}
	}
</style>